// Rettifiche dell'estratto conto operativo (mandati a consuntivo): correggono ore, km e
// spese verso il cliente senza toccare i report, che restano invariati per i collaboratori.
// Salvate in datiAggiuntiviJson.rettifiche_estratto; stessa somma in AmministrazioneService.

export type VoceEstratto = 'ORE_FERIALI' | 'ORE_FESTIVE' | 'KM' | 'SPESE';

export interface RettificaEstratto {
    id: string;
    voce: VoceEstratto;
    // Con segno: −10 km, +2 h, −9,50 €.
    quantita: number;
    nota?: string;
}

export const VOCI_ESTRATTO: VoceEstratto[] = ['ORE_FERIALI', 'ORE_FESTIVE', 'KM', 'SPESE'];

// Descrizione fissa della rettifica, mostrata nell'estratto conto.
export const VOCE_ESTRATTO_LABEL: Record<VoceEstratto, string> = {
    ORE_FERIALI: 'Rettifica ore feriali',
    ORE_FESTIVE: 'Rettifica ore festive/notturne',
    KM: 'Rettifica km',
    SPESE: 'Rettifica spese varie',
};

export const VOCE_ESTRATTO_UNITA: Record<VoceEstratto, string> = {
    ORE_FERIALI: 'h',
    ORE_FESTIVE: 'h',
    KM: 'km',
    SPESE: '€',
};

export type SommeRettificheEstratto = Record<VoceEstratto, number>;

export const parseRettificheEstratto = (raw: any): RettificaEstratto[] =>
    Array.isArray(raw)
        ? raw.filter(r => r && VOCI_ESTRATTO.includes(r.voce)).map(r => ({
            id: String(r.id ?? `${Date.now()}-${Math.random()}`),
            voce: r.voce as VoceEstratto,
            quantita: Number(r.quantita) || 0,
            ...(r.nota ? { nota: String(r.nota) } : {}),
        }))
        : [];

export const sommaRettificheEstratto = (list: RettificaEstratto[]): SommeRettificheEstratto => {
    const out: SommeRettificheEstratto = { ORE_FERIALI: 0, ORE_FESTIVE: 0, KM: 0, SPESE: 0 };
    list.forEach(r => { out[r.voce] += Number(r.quantita) || 0; });
    return out;
};

// Formatta una quantità con segno e unità: "+2 h", "−10 km", "−9,50 €".
export const formatQuantitaEstratto = (voce: VoceEstratto, q: number, conSegno = true): string => {
    const segno = conSegno ? (q < 0 ? '−' : '+') : (q < 0 ? '−' : '');
    const abs = Math.abs(q);
    const num = voce === 'SPESE'
        ? abs.toLocaleString('it-IT', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
        : abs.toLocaleString('it-IT', { maximumFractionDigits: 2 });
    return voce === 'SPESE' ? `${segno}€ ${num}` : `${segno}${num} ${VOCE_ESTRATTO_UNITA[voce]}`;
};
